import React from "react";

export const title = (props) =>  <h1 id={'title'} style={{fontSize: props}}>OneSide</h1>;

export const siteHelper = {
  0 : 0,
  1 : 1,
  2 : 3,
  3 : 4
};

export const swap = (arr, sd, sy, colorIndex =[])=> {
  switch (sd) {
    case 0: {
      [arr[sy], arr[sy+3]] = [arr[sy+3], arr[sy]];
      [arr[sy+4], arr[sy+1]] = [arr[sy+1], arr[sy+4]];
      colorIndex[sy] = colorIndex[sy+3] =
        colorIndex[sy+1] = colorIndex[sy+4] = 'rgba(33, 150, 243, 0.62)';
      break;
    }
    case 1: {
      [arr[sy], arr[sy+1]] = [arr[sy+1], arr[sy]];
      [arr[sy+4], arr[sy+3]] = [arr[sy+3], arr[sy+4]];
      colorIndex[sy] = colorIndex[sy+3] =
        colorIndex[sy+1] = colorIndex[sy+4] = 'rgb(255, 152, 0, 0.77)';
      break;
    }
    default: {
      console.log('Fatt gaya code!');
      break;
    }
  }
};

const columns = (props) =>
  (<div key={props.idx} className={"game-piece mb-2 " +
  props.marginRight} style={{background: props.cIndex[props.idx-1]}}
  >{props.copy[props.idx-1]}
    <span className={'random-val'}>{props.ele}</span>
  </div>);

const row = (props) => {
  let idx = props.idx;
  let copy = props.stateArr;
  let cIndex = props.cIndex;
  const cols  = props.arrChunk.map((ele, i) => {
    const marginRight = !(i===2) ? 'mr-2' : '';
    idx++;
    return columns({idx, ele, marginRight, copy, cIndex});
  });

  return(
    <div key = {idx} className={'row'}>
      {cols}
    </div>
  )
};

export const board = (arr, stateArr, cIndex) => {
  const boardBuild = [];
  for(let i=0; i<3; i++) {
    let arrChunk = arr.slice(i*3, i*3+3);
    let idx = i*3;
    boardBuild.push(row({arrChunk, idx, stateArr, cIndex}));
  }
  return boardBuild;
};